import { render } from "./EditAttributeMaster.vue?vue&type=template&id=47d321e7"
import script from "./EditAttributeMaster.vue?vue&type=script&lang=js"
export * from "./EditAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__